import {defineStore} from "pinia";
import {useShareStore} from "@/store/share";

export const useAuthStore = defineStore("auth", () => {

    // initialize share store
    const shareStore = useShareStore();

    const config = useRuntimeConfig();

    const apiUrl = config.public.apiUrl;

    // current user data
    const currentUserData = reactive({
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        roles: null,
        columns_resume: [],
        created_at: null,
        updated_at: null
    });

    // sign in form input
    const signInFormInput = reactive({
        email: "",
        password: ""
    });

    async function signInWithEmailPassword() {
        try {

            shareStore.setProcess(shareStore.actionProcess.auth.signInWithEmailPassword);
            shareStore.clearErrorResponse();

            // request for sign in with email by password
            const query = `
           mutation($email: String,$password: String){
               signInWithEmailPassword(
                      email: $email
                      password: $password
                   ){
                        user_data{
                            id
                            email
                            first_name
                            last_name
                            meta{
                              meta_key
                              meta_value
                            }
                            created_at
                            updated_at
                        }
                        type_token
                        access_token
                        expire_token
                   }
           }
        `;
            const request = await $fetch(apiUrl, {
                method: "POST",
                body: JSON.stringify({
                    query: query,
                    variables: {
                        email: signInFormInput.email,
                        password: signInFormInput.password
                    }
                })
            });
            if (!request.errors) {
                const tokenCookie = useCookie('tokenAccess');
                tokenCookie.value = request.data.signInWithEmailPassword.access_token;
            }

            // check validation error response
            if (request.errors && request.errors[0].validation) {
                const firstKey = Object.keys(request.errors[0].validation)[0];
                const firstValue = request.errors[0].validation[firstKey][0];
                shareStore.setErrorResponse(firstValue, firstKey);
                return;
            }

            // check message error response
            if (request.errors && request.errors[0].message) {
                shareStore.showSnackBar(request.errors[0].message);
            }

            // set user data and redirection to '/'
            if (request.data.signInWithEmailPassword) {
                currentUserData.id = request.data.signInWithEmailPassword.user_data.id;
                currentUserData.first_name = request.data.signInWithEmailPassword.user_data.first_name;
                currentUserData.last_name = request.data.signInWithEmailPassword.user_data.last_name;
                currentUserData.email = request.data.signInWithEmailPassword.user_data.email;
                currentUserData.created_at = request.data.signInWithEmailPassword.user_data.created_at;
                currentUserData.updated_at = request.data.signInWithEmailPassword.user_data.updated_at;
                request.data.signInWithEmailPassword.user_data.meta.forEach(meta => {

                    /** set roles **/
                    if (meta.meta_key === 'roles') {
                        currentUserData.roles = meta.meta_value;
                    }

                    /** set columns resume **/
                    if (meta.meta_key === 'columns_resume') {
                        currentUserData.columns_resume = meta.meta_value;
                    }

                });
                return navigateTo('/admin/resumes');
            }

        } catch (error) {
            shareStore.showSnackBar("Server Error!");
        } finally {
            shareStore.clearProcess();
        }
    }

    async function checkIsAuthorized() {
        try {
            const tokenCookie = useCookie('tokenAccess');
            shareStore.setProcess(shareStore.actionProcess.auth.checkIsAuthorized);
            const query = `
           {
                me {
                  id
                  first_name
                  last_name
                  email
                  meta{
                    meta_key
                    meta_value
                  }
                  created_at
                  updated_at
                }
           }`;
            const request = await $fetch(apiUrl, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${tokenCookie.value}`,
                },
                body: JSON.stringify({
                    query: query
                })
            });
            if (request.errors) {
                tokenCookie.value = "";
            }
            if (request.data.me) {
                currentUserData.id = request.data.me.id;
                currentUserData.first_name = request.data.me.first_name;
                currentUserData.last_name = request.data.me.last_name;
                currentUserData.email = request.data.me.email;
                request.data.me.meta.forEach((item) => {

                    if (item.meta_key === 'roles') {
                        currentUserData.roles = item.meta_value;
                    }

                    /** set columns resume **/
                    if (item.meta_key === 'columns_resume') {
                        currentUserData.columns_resume = item.meta_value;
                    }

                });
                currentUserData.created_at = request.data.me.created_at;
                currentUserData.updated_at = request.data.me.updated_at;
            }
        } catch (error) {

        } finally {
            shareStore.clearProcess();
        }
    }

    async function logOut() {
        try {

            shareStore.setProcess(shareStore.actionProcess.auth.logOut);

            const tokenCookie = useCookie('tokenAccess');
            tokenCookie.value = "";

            // logout and redirection to '/sign-in'
            currentUserData.id = null;
            currentUserData.first_name = null;
            currentUserData.last_name = null;
            currentUserData.email = null;
            currentUserData.roles = null;
            currentUserData.created_at = null;
            currentUserData.updated_at = null;
            return navigateTo("/sign-in");

        } finally {
            shareStore.clearProcess();
        }
    }

    return {
        signInFormInput,
        currentUserData,
        signInWithEmailPassword,
        checkIsAuthorized,
        logOut
    }

});